import React from "react";
import { FaShieldAlt, FaGlobe, FaExchangeAlt } from "react-icons/fa";

function EnhancedUserSecurity() {
  return (
    <>
      <div
        className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="site-heading">
                <h4 className="sub-title">Our Features</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Why Launch a Web3 Wallet?
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="fade-up-anim">
            <div className="row">
              <div className="col-xl-12">
                <div className="feature-style-three-items fade-up-anim">
                  <div className="feature-style-one hover-active-item ">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaShieldAlt size={35} />
                      </div>
                      <h4>Enhanced User Security</h4>
                      <p>
                        Web3 wallets give users full control over their private
                        keys, minimizing the risks associated with third-party
                        custodians and providing stronger protection for digital
                        assets.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one hover-active-item">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaGlobe size={35} />
                      </div>
                      <h4>Access to Decentralized Ecosystems</h4>
                      <p>
                        By launching a Web3 wallet, users can easily connect
                        with decentralized applications (dApps), unlocking
                        opportunities in DeFi, NFT trading, and blockchain-based
                        gaming.
                      </p>
                    </div>
                  </div>

                  <div className="feature-style-one hover-active-item">
                    <div className="content d-flex flex-column items-center">
                      <div className="icon">
                        <FaExchangeAlt size={35} />
                      </div>
                      <h4>Cross-Chain Compatibility</h4>
                      <p>
                        A Web3 wallet supports multiple blockchain protocols,
                        allowing users to manage different cryptocurrencies and
                        tokens from one interface, increasing convenience and
                        flexibility.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EnhancedUserSecurity;
